var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 491.3 384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#22272e;}.cls-2{fill:#6dafa7;}.cls-3{fill:#ffe779;}.cls-4{fill:none;stroke:#63737a;stroke-linecap:round;stroke-linejoin:round;stroke-width:12.69px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.28,275.53,77.73,300.21c-3.53,3.52-3.53,9.87,0,14.1h0a10.79,10.79,0,0,0,12.69,2.11l26.78-16.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.12,335.45l6.34,33.13c.71,4.94-2.11,10.58-7,12h0a9.73,9.73,0,0,1-12-5.64l-14.1-28.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 230.69,
    cy: 210.68,
    r: 153.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 230.59,
    cy: 210.84,
    r: 98.68,
    transform: "translate(-81.55 224.8) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "258.19 245.93 230.69 210.68 245.5 161.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.71,62a8.21,8.21,0,0,1-10.57-5.64,44.69,44.69,0,0,1,81.77-31c2.82,4.23.7,9.16-4.23,11.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M392.82,138.08a8.12,8.12,0,0,0,12,.7c14.1-15.51,15.51-38.77,2.11-56.39S371,59.83,352.64,69c-4.23,2.11-5.64,7.75-2.82,11.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.48,45.73,260.3,34.45C254,32.34,249.73,26,251.84,19h0c2.12-6.35,8.46-10.58,15.51-8.46l40.18,11.28c6.34,2.11,10.57,8.46,8.46,15.5h0C313.87,43.62,306.82,47.85,300.48,45.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 256.97,
    y: 36.39,
    width: 39.48,
    height: 30.31,
    transform: "translate(150.01 302.88) rotate(-73.8)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.fc2fbe749d0261c685cbf15eacc4fa16.svg";
export { ForwardRef as ReactComponent };